export default __webpack_public_path__ + "static/travel1-a5c2276fa29a22912ced190bd1797787.png";